import { HttpClient } from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from "@shared/src/services/alert/alert.service";
import { LoadingService } from "@shared/src/services/loading/loading.service";
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { BaseController } from "../../base.controller";
import { SecurityController } from "../../security/security.controller";
import { FileUpDownLoadDto } from "@shared/src/dtos/base/FileUpDownLoadDto";
import { FilterLoadLogDto } from "@shared/src/dtos/tenants/loadlog/FilterLoadLogDto";
import { TenantLoadLogDto } from "@shared/src/dtos/tenants/loadlog/TenantLoadLogDto";
import { ProcessTypes } from "@shared/src/public-api";

@Injectable({
    providedIn: 'root',
})
export class TenantLoadLogController extends BaseController {
    private base = '/tenantloadlog';

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        protected router: Router,
        @Inject('LoadingService') protected loadingService: LoadingService) {
        super(http, alertService, translateService, loadingService, router);
    }

    public getInitial(processType: ProcessTypes): Observable<TenantLoadLogDto> {
        return this.postBusy(this.base + "/initial/", FilterLoadLogDto.defaultLoadLog(processType), "getInitials");
    }

    public getLoads(filter: FilterLoadLogDto, busy: boolean = false): Observable<TenantLoadLogDto> {
        return this.postBusy(this.base + "/", filter, "getLoads");
    }

    public downloadFileProcess(tenantLoadLogId: number): Observable<FileUpDownLoadDto> {
        return this.getBusy(this.base + "/download/fileprocess/" + tenantLoadLogId);
    }
    public downloadAll(filter: FilterLoadLogDto): Observable<FileUpDownLoadDto> {
        return this.postBusy(this.base + "/download/fileprocess/all", filter, "downloadAll");
    }

    public downloadFileResult(tenantLoadLogId: number): Observable<FileUpDownLoadDto> {
        return this.getBusy(this.base + "/download/fileresult/" + tenantLoadLogId);
    }
    public cancel(tenantLoadLogId: number): Observable<FileUpDownLoadDto> {
        return this.post(this.base + "/cancel/" + tenantLoadLogId, "", "TenantLoadLogControllerCancel");
    }
}